// MOMKIS - Accordéon FAQ exclusif (homepage + collections)
// Ouvrir une question ferme automatiquement les autres questions du même
// bloc FAQ. Repose sur les <details>/<summary> natifs déjà en place :
// aucune modification du DOM, aucune dépendance externe, clavier natif
// préservé. L'événement 'toggle' des <details> ne remonte pas (bubble)
// mais traverse bien les ancêtres en phase de capture : on écoute donc
// en capture (dernier argument = true).
document.querySelectorAll('.momkis-faq-accordion__list, .momkis-faq__list').forEach(function (list) {
  list.addEventListener(
    'toggle',
    function (event) {
      var target = event.target;
      if (!(target instanceof HTMLDetailsElement) || !target.open) return;
      list.querySelectorAll('details[open]').forEach(function (details) {
        if (details !== target) details.removeAttribute('open');
      });
    },
    true
  );
});
